import React from "react";
import { useNavigate , Link} from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-ai-01.jpg";
import aiImg from "../../assets/img/ai-WISplatform.png";
import aiIcon01 from "../../assets/img/icon-ai01.png";
import aiIcon02 from "../../assets/img/icon-ai02.png";
import aiIcon03 from "../../assets/img/icon-ai03.png";
import aiIcon04 from "../../assets/img/icon-ai04.png";
import fwImg from "../../assets/img/fw-wisplatform.png";

function WISplatform() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';


   //이미지 클릭
  const imgClick = () => {
    const img = new Image();
    img.src = fwImg;

    img.onload = () => {
      // 이미지 실제 원본 크기 가져오기
      const imgWidth = img.naturalWidth || img.width;
      const imgHeight = img.naturalHeight || img.height;
      
      // 창 크기를 1200px로 고정하고 반응형으로 조정, 높이는 이미지 비율에 맞춤
      const w = Math.min(1200, window.innerWidth * 0.94);
      const aspectRatio = imgHeight / imgWidth;
      const h = w * aspectRatio;

      // 창을 현재 모니터 중앙에 위치시키기 (듀얼모니터 환경 고려)
      const currentScreenLeft = window.screen.availLeft || 0;
      const currentScreenWidth = window.screen.availWidth;
      const left = currentScreenLeft + (currentScreenWidth - w) / 2;
      const top = (window.screen.height - h) / 2;

      // HTML 페이지를 만들어서 이미지와 파비콘을 함께 표시
      const htmlContent = `
        <!DOCTYPE html>
        <html lang="ko">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>WISplatform 프레임워크</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
              overflow: auto;
            }
            .image-container {
              width: 100%;
              height: 100%;
              text-align: center;
              padding: 0;
              overflow: visible;
            }
            .image-container img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              cursor: pointer;
              transition: transform 0.3s ease;
              transform-origin: top left;
            }
            .image-container img.zoomed {
              cursor: zoom-out;
            }
          </style>
          <script>
            function toggleZoom(img) {
              if (img.classList.contains('zoomed')) {
                // 축소: 원본 크기로
                img.style.transform = 'scale(1.0)';
                img.classList.remove('zoomed');
              } else {
                // 확대: 1.5배 또는 이미지 원본 크기 제한
                const imgNaturalWidth = ${imgWidth};
                const containerWidth = ${w};
                const scale1_5 = 1.5;
                const scale1_5Width = containerWidth * scale1_5;
                
                // 1.5배 크기가 이미지 원본보다 크면 원본 크기로, 작으면 1.5배로
                let finalScale;
                if (scale1_5Width > imgNaturalWidth) {
                  finalScale = imgNaturalWidth / containerWidth;
                } else {
                  finalScale = scale1_5;
                }
                
                img.style.transform = 'scale(' + finalScale + ')';
                img.classList.add('zoomed');
              }
            }
          </script>
        </head>
        <body>
          <div class="image-container">
            <img src="${fwImg}" alt="WISaicc 프레임워크" onclick="toggleZoom(this)" />
          </div>
        </body>
        </html>
      `;

      // 새 창 열기 - 이미지 비율에 맞춘 높이로
      const newWindow = window.open(
        "",
        "_blank",
        `width=${w},height=${h},left=${left},top=${top},resizable=yes,scrollbars=yes,menubar=no,toolbar=no,location=no,status=no`
      );

      if (newWindow) {
        newWindow.document.write(htmlContent);
        newWindow.document.close();
      }
    };
  };

  //파일다운로드
    const downloadFile = async () => {
    const response = await fetch("/download/brochure");
    const blob = await response.blob();
  
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "위피아_AI솔루션.pdf";
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };
  
    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
            <span className="ko">AI 통합 플랫폼</span>
						<h2>WISplatform</h2>
						<p>다양한 AI 솔루션(문서·음성·검색·비전·챗봇 등)을 하나의 통합 환경에서 관리/운영/확장할 수 있는 엔터프라이즈 AI 플랫폼입니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my ai-business-wrap">
        <section className="aiCont">
          <h4 className="title">
            <span>연관 솔루션</span>
          </h4>

          <h5 className="title">기업·기관의 비즈니스 프로세스를 혁신하세요!</h5>
          <p className="text">조직 내 모든 유형의 <span className="blue">AI 서비스와 데이터</span>를 손쉽게 연결하고, 통합된 환경에서 안전하게 운영·확장할 수 있는 엔터프라이즈 AI 허브이자, 업무 혁신의 디지털 플랫폼입니다.<br/>
          <span className="blue">복수의 AI 엔진, 멀티모달 데이터, 외부/기존 IT 시스템 및 다양한 채널</span>과의 연계를 필요로 하는 기업·기관에 특히 적합합니다.<br/>
          플랫폼 도입 시 즉각적 디지털 전환 효과와 <span className="blue">지속적 AI 확장 기반</span>을 함께 확보할 수 있습니다.</p>
          <ul className="link-wrap">
            <li> <Link to="/WISaicc">WISaicc <i></i></Link></li>
            <li> <Link to="/WISbot">WISbot <i></i></Link></li>
            <li> <Link to="/WISserch">WISsearch <i></i></Link></li>
            <li> <Link to="/WISvec">WISvec <i></i></Link></li>
            <li> <Link to="/WISrag">WISrag <i></i></Link></li>
            <li> <Link to="/WISdoc">WISdoc <i></i></Link></li>
            <li> <Link to="/WISscrap">WISscrap <i></i></Link></li>
            <li> <Link to="/WISocr">WISocr <i></i></Link></li>
            <li> <Link to="/WISvoice">WISvoice <i></i></Link></li>
            <li> <Link to="/WISvision">WISvision <i></i></Link></li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
          <span>WISplatform 이란?</span>
        </h4>
        <div className="textWrap">
            <div className="ai-ci"><img src={aiImg} alt="WISplatform" /></div>
            <div className="info">
              <p>WISplatform은 다양한 AI 기술과 비즈니스 시스템을 통합·관리·운영할 수 있도록 설계된 ‘엔터프라이즈 AI 통합 플랫폼’입니다. 이 플랫폼은 문서, 음성, 이미지, 챗봇, 검색, 데이터 분석 등 여러 AI 서비스(예: WISdoc, WISocr, WISrag 등)를 하나의 프레임워크에서 연결·확장하며, 실질적인 디지털 전환과 업무 자동화, 데이터 기반 의사결정 환경을 제공합니다.</p>

              <ul className="list">
                <li>
                  <p className="tit">AI 서비스 통합 운용</p>
                  <p className="txt">문서, 음성, 비전(이미지/영상), 챗봇, 검색 등 각종 AI 기능 통합 배포 및 사용량‧품질 관리</p>
                </li>
                 <li>
                  <p className="tit">데이터 파이프라인/전처리 자동화</p>
                  <p className="txt">데이터 수집, 정제, 변환, 저장, 학습 데이터셋 구축까지 
전 과정 자동화 지원</p>
                </li>
                 <li>
                  <p className="tit">모델 학습‧배포 관리</p>
                  <p className="txt">LLM, RAG, 벡터검색, 음성·비전 모델 등 다양한 AI 모델의 개발, 학습, 배포, 버전관리</p>
                </li>
                 <li>
                  <p className="tit">워크플로우 및 프로세스 자동화</p>
                  <p className="txt">RPA, 챗봇, 콜센터, 보고서 자동화 등 현업 업무 플로우와 AI 기능을 결합하여 업무 프로세스 혁신</p>
                </li>
              </ul>
            </div>
        </div>
        </section>

        <section className="aiCont">
          <h4 className="title ">
            <span>특장점</span>
          </h4>
          <ul className="textWrap feature-list">
            <li>
              <span className="icon"><img src={aiIcon01} alt="End-to-End AI 환경"/></span>
              <p className="tit">End-to-End AI<br/> 환경</p>
              <p className="txt">데이터 수집 ~ AI 분석·생성 ~ 업무 자동화 ~ 모니터링까지 전 단계를 하나의 플랫폼에서 통합적으로 지원</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon02} alt="사용자 친화적 관리"/></span>
              <p className="tit">사용자 <br />친화적 관리</p>
              <p className="txt">대시보드, 워크플로우 구성 등 비전문가도 손쉽게 운영할 수 있는 UI/UX 제공</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon03} alt="다양한 산업 및 현장 적용성"/></span>
              <p className="tit">다양한 산업 및 <br />현장 적용성</p>
              <p className="txt">고객지원, 보고서 자동화, R&D, 사내 지식관리, 판매·유통, 제조 현장 등 다양한 업무 시나리오에 즉시 적용</p>
            </li>
            <li>
              <span className="icon"><img src={aiIcon04} alt="엔터프라이즈 보안·확장성"/></span>
              <p className="tit">엔터프라이즈<br />보안·확장성</p>
              <p className="txt">엄격한 역할기반 보안, 벡터DB/온톨로지 등 고도 AI 기술, 멀티모달 데이터 처리까지 폭넓게 지원</p>
            </li>
          </ul>
        </section>
        <section className="aiCont">
          <h4 className="title ">
            <span>아키텍처</span>
          </h4>
          <ul className="textWrap ac-list">
              <li>
                <p className="tit">데이터 수집 및 연동</p>
                <p className="txt">(내부시스템/외부데이터의 수집, 연동)</p>
              </li>
              <li>
                <p className="tit">데이터 파이프라인 및 전처리</p>
                <p className="txt">(데이터를 정제, 클렌징, 변환)</p>
              </li>
              <li>
                <p className="tit">AI 모델 관리 및 서비스</p>
                <p className="txt">(다수의 AI 모델을 통합 관리)</p>
              </li>
              <li>
                <p className="tit">응용·서비스 통합</p>
                <p className="txt">(업무별 맞춤형 솔루션 구현)</p>
              </li>
              <li>
                <p className="tit">보안 및 권한 관리</p>
                <p className="txt">(데이터와 AI 서비스 의 보안을 유지)</p>
              </li>
              <li>
                <p className="tit">모니터링·관리 및 사용자 인터페이스</p>
                <p className="txt">(AI 기능을 사용자에게 제공)</p>
              </li>
            </ul>
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>프레임워크</span>
          </h4>
          <div className="textWrap framework"  onClick={imgClick}>
              <img src={fwImg} alt="WISplatform 프레임워크"/>
          </div>
          
        </section>

        <section className="aiCont">
          <h4 className="title">
            <span>활용사례</span>
          </h4>
          <ul className="textWrap case-list">
              <li>
                <p className="tit">기업 FAQ·고객지원 챗봇</p>
                <p className="txt">사내 문서·제품 매뉴얼·정책 Q&A를 정확히 답변하고, 명확한 지식 서비스 제공</p>
              </li>
                <li>
                <p className="tit">내부 지식 검색 및 보고서 생성</p>
                <p className="txt">방대한 내부 문서/리포트/가이드에서 원하는 정보를 실시간 추출, 맞춤형 보고서 자동 생성</p>
              </li>
                <li>
                <p className="tit">데이터 기반 의사결정 지원</p>
                <p className="txt">실시간 쿼리에 근거가 명시된 객관적 결과 전달(예: 법률, R&D, 정책 등)</p>
              </li>
                <li>
                <p className="tit">전문 정보의 빠른 전파와 관리</p>
                <p className="txt">기업 내 프라이빗 환경에서만 동작하며, 외부유출 없이 내부 지식 활용</p>
              </li>
          </ul>
          
        </section>

        <section className="aiCont">
          <div className="btnWrap">
            <button type="button" className="inquiry-btn" onClick={downloadFile}>브로슈어 다운로드</button>
          </div>
        </section>
        
        
			</section>
		</main>
	<Footer />

        </>
    )
}

export default WISplatform;